import React, { useEffect, useState } from 'react';
import './CierreDia.css';
import axios from '../api';

const CierreDiaTable = ({ cierres, setCierres, onEditar, recargarTabla, sumReportadoByCierreDia }) => {
  const [editandoId, setEditandoId] = useState(null);
  const [datosEditados, setDatosEditados] = useState({});

  useEffect(() => {
    console.log('CierreDiaTable recibió cierres:', cierres);
  }, [cierres]);

  const formatMoneda = (valor) => {
    if (valor === null || valor === undefined) return '0';
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(valor);
  };

  const formatFechaSegura = (fecha) => {
    try {
      if (!fecha) return '';
      const date = new Date(fecha);
      if (isNaN(date.getTime())) return '';
      return date.toLocaleDateString('es-CO');
    } catch (error) {
      console.error('Error al formatear fecha:', error);
      return '';
    }
  };

  const iniciarEdicion = (id, cierre) => {
    setEditandoId(id);
    setDatosEditados(cierre);
  };

  const manejarCambio = (e, campo) => {
    const valor = e.target.value;
    setDatosEditados((prev) => ({ ...prev, [campo]: valor }));
  };

  const cancelarEdicion = () => {
    setEditandoId(null);
    setDatosEditados({});
  };

  const guardarCambios = async () => {
    try {
      const payload = {
        ...datosEditados,
        totalEfectivoDia: datosEditados.totalEfectivoDia !== undefined ? Number(datosEditados.totalEfectivoDia) : undefined,
        idPlanilla: datosEditados.idPlanilla !== undefined ? String(datosEditados.idPlanilla) : null,
        transmitido: datosEditados.transmitido === '1' || datosEditados.transmitido === 1 || datosEditados.transmitido === true ? 1 : 0
      };
      await axios.patch(
        `/cierres-dias/${editandoId}`,
        payload
      );
      if (recargarTabla) {
        await recargarTabla(); // Espera a que termine la recarga
      } else if (setCierres) {
        // Actualizar en pantalla local si no hay recarga
        setCierres(prev =>
          prev.map(c => (c.idCierreDia === editandoId ? { ...c, ...payload } : c))
        );
      }
      alert('Cierre de día actualizado con éxito');
      setEditandoId(null);
    } catch (error) {
      console.error('Error al guardar cambios:', error);
      alert('Hubo un error al actualizar los datos.');
    }
  };

  if (!Array.isArray(cierres)) {
    console.error('cierres no es un array:', cierres);
    return <div>No hay datos disponibles</div>;
  }

  if (cierres.length === 0) {
    return <div>No se encontraron registros</div>;
  }

  return (
    <div className="table-container">
      <table className="cierre-turno-table">
        <thead>
          <tr>
            <th>Cod.Empleado</th>
            <th>Fecha Ini</th>
            <th>Total</th>
            <th>Subtotal</th>
            <th>Reportado</th>
            <th>Total Efectivo</th>
            <th>Estado</th>
            <th>Transmitido</th>
            <th>id_planilla</th>
            <th>Id Inicio Dia</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {cierres.map((cierre) => {
            const id = cierre.idCierreDia || cierre.id;
            const enEdicion = id === editandoId;
            return (
              <tr key={id}>
                <td>{cierre.codEmpleado}</td>
                <td>{formatFechaSegura(cierre.fechaInicial)}</td>
                <td className="valor-monetario">{formatMoneda(cierre.total)}</td>
                <td className="valor-monetario">{formatMoneda(cierre.subtotal)}</td>
                <td>
                  {sumReportadoByCierreDia != null && (cierre.idCierreDia ?? cierre.id) != null && sumReportadoByCierreDia[cierre.idCierreDia ?? cierre.id] !== undefined ? (
                    formatMoneda(sumReportadoByCierreDia[cierre.idCierreDia ?? cierre.id])
                  ) : enEdicion ? (
                    <input
                      type="number"
                      value={datosEditados.totalEfectivoDia || ''}
                      onChange={(e) => manejarCambio(e, 'totalEfectivoDia')}
                    />
                  ) : (
                    formatMoneda(cierre.totalEfectivoDia)
                  )}
                </td>
                <td className="valor-monetario">{formatMoneda(cierre.totalEfectivo)}</td>
                <td>
                  {enEdicion ? (
                    <select
                      name="estado"
                      value={datosEditados.estado || ''}
                      onChange={(e) => manejarCambio(e, 'estado')}
                    >
                      <option value="1">Activo</option>
                      <option value="3">Inactivo</option>
                      <option value="2">Descuadrado</option>
                    </select>
                  ) : (
                    cierre.estado
                  )}
                </td>
                <td>
                  {enEdicion ? (
                    <select
                      name="transmitido"
                      value={datosEditados.transmitido === true || datosEditados.transmitido === 1 ? '1' : '0'}
                      onChange={e => manejarCambio({ target: { value: e.target.value === '1' ? 1 : 0 } }, 'transmitido')}
                    >
                      <option value="1">Sí</option>
                      <option value="0">No</option>
                    </select>
                  ) : (
                    cierre.transmitido ? 'Sí' : 'No'
                  )}
                </td>
                <td>
                  {enEdicion ? (
                    <input
                      type="text"
                      value={datosEditados.idPlanilla || ''}
                      onChange={(e) => manejarCambio(e, 'idPlanilla')}
                    />
                  ) : (
                    cierre.idPlanilla
                  )}
                </td>
                <td>{cierre.idInicioDia}</td>
                <td className="acciones-centrado acciones-botones">
                  {enEdicion ? (
                    <>
                      <button onClick={guardarCambios} className="editar-btn">Guardar</button>
                      <button onClick={cancelarEdicion} className="cancelar-btn">Cancelar</button>
                    </>
                  ) : (
                    <button onClick={() => iniciarEdicion(id, cierre)} className="editar-btn">Editar</button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CierreDiaTable;
